export default "__VITE_ASSET__qOaV_cPN__"